import React from 'react';

import { Control, FieldErrors, UseFormSetValue, UseFormWatch } from 'react-hook-form';

import { QueryResponse as IBoardInitResponse } from 'api/queries/getBoardInitLite.query';

import { IFields } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/CreateCardModal/CreateCardModal.types';
import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/CreateCardModal/components/CardContent/CardContent.module.scss';
import { CardDetails } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/CreateCardModal/components/CardContent/components/CardDetails/CardDetails';

interface Props {
    boardInit: IBoardInitResponse | undefined;
    setValue: UseFormSetValue<IFields>;
    watch: UseFormWatch<IFields>;
    control: Control<IFields, IFields>;
    errors: FieldErrors<IFields>;
}

export const CardContent = ({ boardInit, setValue, watch, control, errors }: Props) => {
    return (
        <div className={classes.cardContentContainer}>
            <CardDetails boardInit={boardInit} setValue={setValue} watch={watch} control={control} errors={errors} />
        </div>
    );
};
